import React, { useRef, useState } from 'react';
import './AdvancedFilterButton.scss';
import { useOutsideHandler } from '../../utils/outside-click-handler';
import { useTranslation } from 'react-i18next';
import ionFilter from '../../assets/icons/filter.svg';
import { ASSETS_URL } from '../../constants';

interface FilterOption {
  id: string;
  name: string;
}

interface Props {
  sectorOptions: FilterOption[];
  jobTypeOptions: FilterOption[];
  selectedSectors: string[];
  selectedJobTypes: string[];
  onToggleSector: (id: string) => void;
  onToggleJobType: (id: string) => void;
  activeCount: number;
}

const AdvancedFilterButton = ({
  sectorOptions,
  jobTypeOptions,
  selectedSectors,
  selectedJobTypes,
  onToggleSector,
  onToggleJobType,
  activeCount,
}: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLInputElement>(null);
  useOutsideHandler(wrapperRef, setIsOpen);

  return (
    <div className='adv-filter' ref={wrapperRef}>
      <button
        className={`adv-filter__button ${activeCount > 0 ? 'adv-filter__button--active' : ''}`}
        onClick={() => setIsOpen((v) => !v)}
      >
        <img src={ASSETS_URL + ionFilter} alt='filter' />
        <span>{t('candidateHomePage.filter.advancedButton')}</span>
        {activeCount > 0 && (
          <span className='adv-filter__badge'>{activeCount}</span>
        )}
      </button>

      {isOpen && (
        <div className='adv-filter__panel'>
          <div className='adv-filter__section'>
            <p className='adv-filter__section-title'>
              {t('candidateHomePage.filter.industrySector')}
            </p>
            {sectorOptions.map((opt) => (
              <label key={opt.id} className='adv-filter__option'>
                <input
                  type='checkbox'
                  checked={selectedSectors.includes(opt.id)}
                  onChange={() => onToggleSector(opt.id)}
                />
                <span>{opt.name}</span>
              </label>
            ))}
          </div>

          <div className='adv-filter__divider' />

          <div className='adv-filter__section'>
            <p className='adv-filter__section-title'>
              {t('candidateHomePage.filter.contractType')}
            </p>
            {jobTypeOptions.map((opt) => (
              <label key={opt.id} className='adv-filter__option'>
                <input
                  type='checkbox'
                  checked={selectedJobTypes.includes(opt.id)}
                  onChange={() => onToggleJobType(opt.id)}
                />
                <span>{opt.name}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedFilterButton;
